import React from "react";
import InputField from "./InputField";
import Dropdown from "./Dropdown";
import Switch from "./Switch";
import { format, parseISO } from "date-fns";
import ToolTip from "./ToolTip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";

const EditForm = ({ 
  data, 
  setData, 
  setHasChanges, 
  disabled, 
  fields, 
  dropdownOptions = {} 
}) => {

  const formatDate = (date) => {
    if (!date) return "";
    try {
      return format(parseISO(date), "yyyy-MM-dd");
    } catch (error) {
      return date; 
    }
  };

  const handleInputChange = (field, value) => {
    setData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    setHasChanges(true);
  };

  return (
    <div className="grid grid-cols-2 gap-6 w-full">
      {fields.map(({ key, label, type, tooltip, disabled: fieldDisabled }) => ( 
        <div key={key} className="flex flex-col gap-4">
          {type === "dropdown" ? (
            <Dropdown
              label={label}
              value={data?.[key] || ""}
              options={(dropdownOptions[key] || []).map((g) => g.name)} 
              onSelect={(option) => {
                handleInputChange(key, option);

                if (key === "billingGroupName" && dropdownOptions[key]) {
                  const selectedGroup = dropdownOptions[key].find((g) => g.name === option);

                  if (selectedGroup) {
                    setData((prevData) => ({
                      ...prevData,
                      billingGroupName: selectedGroup.name,
                      billingGroupPublicId: selectedGroup.billingGroupPublicId, 
                    }));
                    setHasChanges(true);
                  }
                }
              }}
              disabled={fieldDisabled ?? disabled}
            />
          ) : type === "switch" ? (
            <div className="flex flex-col w-1/2">
              <label className="text-sm font-bold pb-2">{label}</label>
              <div className="flex items-center space-x-2">
                <Switch
                  checked={data?.[key] || false}
                  onChange={(checked) => handleInputChange(key, checked)}
                  disabled={fieldDisabled ?? disabled} 
                />
                <p className="text-sm">{data?.[key] ? "Enabled" : "Disabled"}</p>
              </div>
            </div>
          ) : (
            <div className="flex flex-col">
              <label className="text-sm font-bold flex space-x-2">
                <span>{label}</span>
                {tooltip && (
                  <ToolTip text={tooltip}>
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      className="text-gray-400 text-md"
                    />
                  </ToolTip>
                )}
              </label>
              <InputField
                placeholder={label}
                type={type}
                value={type === "date" ? formatDate(data?.[key]) : data?.[key] || ""}
                onChange={(e) => handleInputChange(key, e.target.value)}
                readOnly={type === "readonly"}
                className="w-full"
                disabled={fieldDisabled ?? disabled}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default EditForm;
